import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth, formatApiErrorDetail } from "../../context/AuthContext";
import { LOGIN } from "../../constants/testIds";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin/enquiries");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-black flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white p-8 sm:p-10">
        <div className="flex items-center gap-3 mb-1">
          <Lock className="h-6 w-6 text-brand-gold" strokeWidth={1.5} />
          <h1 className="font-serif text-2xl text-brand-black">Staff sign in</h1>
        </div>
        <p className="text-sm text-brand-darkgrey mb-6">Family Court Guide — internal access only.</p>

        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label className="text-sm font-semibold">Email address</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              data-testid={LOGIN.emailInput} className="rounded-sm focus-visible:ring-brand-gold" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-semibold">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              data-testid={LOGIN.passwordInput} className="rounded-sm focus-visible:ring-brand-gold" />
          </div>
          {error && <p className="text-sm text-brand-danger" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid={LOGIN.submitButton}
            className="w-full bg-brand-black text-white hover:bg-brand-gold rounded-sm">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <div className="mt-5 text-center">
          <Link to="/admin/forgot-password" className="text-sm text-brand-gold hover:text-brand-black" data-testid={LOGIN.forgotPasswordLink}>
            Forgot your password?
          </Link>
        </div>
      </div>
    </div>
  );
}
